const configExtra = {
    // 0=本地测试 1=测试环境 2=uat 3=prod
    hostType: 2,
}

module.exports = configExtra

